<template>
    <div class="content-wrap">
        <div class="tab">
            <div :class="['tab-item', curTab === 0 && 'tab-item-act']" @click="curTab = 0">体验预约</div>
            <div :class="['tab-item', curTab === 1 && 'tab-item-act']" @click="curTab = 1">我的预约</div>
            <div :class="['tab-item', curTab === 2 && 'tab-item-act']" @click="curTab = 2">预约核销</div>
            <div v-if="BshowCheck" :class="['tab-item', curTab === 3 && 'tab-item-act']" @click="curTab = 3">体验间点检</div>
        </div>
        <div class="tab-content">
            <transition name="fade-transform" mode="out-in">
                <keep-alive include="appointExpreise check">
                    <router-view @myappoint='myappoint' @check="check" @writeoff="writeoff"></router-view>
                </keep-alive>
            </transition>
        </div>
    </div>
</template>

<script>
import { fetchVerifyAuthForB} from '@/libsV2/havc.js'
    export default {
        name: "appoint",
        data() {
            return {
                curTab: 0,
                BshowCheck:true,//是否显示点检
            }
        },
        watch: {
            curTab(val) {
                if (val === 0) {
                    this.$router.replace({path: '/hvac/talk/v3/appoint'})
                } else if (val === 1) {
                    this.$router.replace({path: '/hvac/talk/v3/myappoint'})
                } else if (val === 2) {
                    if (this.$route.query.project_id) {
                        this.$router.replace({path: `/hvac/talk/v3/writeoff?project_id=${this.$route.query.project_id}`})
                    } else {
                        this.$router.replace({path: `/hvac/talk/v3/writeoff`})
                    }
                } else if (val == 3) {
                    this.$router.replace({path: '/hvac/talk/v3/check'})
                }
            }
        },
        methods: {
            writeoff () {
                this.curTab = 2
            },
            myappoint () {
                this.curTab = 1
            },
            check () {
                this.curTab = 3
            }
        },
        created () {
            Promise.all([
                this.$store.dispatch({type:'userTalkAppointV3/getIdentity'}),
                this.$store.dispatch({type:'userTalkAppointV3/ProjectGroup'})
            ])
            .then(() => {
                console.log('负责人' + this.$store.state.userTalkAppointV3.BchargePeople,'平台管理'+this.$store.state.userTalkAppointV3.BIdentity);
                // 判断用户是不是平台管理员或者负责人,如果是就显示点检页面,如果不是就不显示点检页面
                if (this.$store.state.userTalkAppointV3.BIdentity || this.$store.state.userTalkAppointV3.BchargePeople) {
                    this.BshowCheck = true
                } else {
                    this.BshowCheck = false
                }
            })
        },
        beforeRouteEnter (to,form,next) {
            fetchVerifyAuthForB (() => {
                next()
          })
        }
    }
</script>

<style lang="scss" scoped>
    .content-wrap {
        min-height: 100vh;
        background: #F0F4F1;

        .tab {
            width: 91.2%;
            margin: 40px auto 28px;
            // margin: 0 auto;
            box-sizing: border-box;
            border-radius: 12px;
            border: 2px solid #318544;
            display: flex;
            justify-content: space-between;
            overflow: hidden;

            .tab-item {
                flex: 1;
                font-size: 28px;
                font-weight: 400;
                color: #318544;
                line-height: 80px;
                text-align: center;
            }

            .tab-item-act {
                background: #318544;
                color: #E5EFE7;
                margin-left: 1px;
            }
        }
    }

    /*动画*/
    .fade-transform-leave-active,
    .fade-transform-enter-active {
        transition: all 0.4s;
    }
    .fade-transform-enter {
        opacity: 0;
        transform: translateX(-30px);
    }
    .fade-transform-leave-to {
        opacity: 0;
        transform: translateX(30px);
    }
</style>
